'use client';

import { Flex, For, Link, Heading, Box } from "@chakra-ui/react";
import ContentBox from "@/components/partials/ContentBox";
import { TheContent } from "@/components/partials/Helpers";
import { LuEqualNot } from "react-icons/lu"

export default function RelatedNews({ posts, label = 'Leia também' }) {
  return (
    <>
      { posts && posts.length > 0 ? (
        <ContentBox padding="8">
          <Heading as="h4" fontFamily="inherit" fontWeight="700" fontSize="2em" pb="4" ineHeight="1" color="orange.500">
            { label }
          </Heading>

          <Flex flexWrap="wrap">
            <For each={posts} >
              {(item, index) => (
                <Flex
                  key={index}
                  borderColor="yellow.500"
                  borderLeftWidth="4px"
                  flex={{ base: '100%', lg: '100%'  }}
                  my="4"
                  py="4"
                  justifyContent="center"
                  flexDirection="column"
                  _hover={{ bgColor: "gray.50"  }}
                  transition="all 0.2s ease"
                >
                  <Link
                    href={item.postPermalink}
                    title={ item.postTitle }
                    pl="4"
                    pb="1"
                    fontSize="1.6em"
                    color="gray.600"
                  >
                    { item.postTitle }
                  </Link>

                  <Link
                    href={item.postPermalink}
                    title={ item.postTitle }
                    pl="4"
                    fontSize="1em"
                    color="gray.500"
                  >
                    <TheContent body={item.postCall || item.postContent} />
                  </Link>
                </Flex>
              )}
            </For>
          </Flex>
        </ContentBox>
      ) : (
        <Box minH="600px">
          <ContentBox>
            <Flex py="20" flexDirection="column" alignItems="center">
            <Box fontSize="7em" color="orange.500">
              <LuEqualNot margin="auto" />
            </Box>

            <Box pt="8" textAlign="center">
              <Box fontSize="2em" fontWeight="300" mb="4">
                Nenhuma notícia encontrada.
              </Box>

              <Box>
                <Link href="/" title="Voltar à Página Inicial" _hover={{ textDecoration: 'underline'}}>Clique aqui</Link> para voltar à página inicial.
              </Box>
            </Box>
            </Flex>
          </ContentBox>
        </Box>
      )}
    </>
  )
}
